import React from 'react'

/**
 * ソースの内容をターゲットにコピーします
 *
 * @param {Object} target ターゲット
 * @param {Object} source ソース
 * @returns マージ後オブジェクト
 */
export const mergeDeep = (target, source) => {
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (source[key] && typeof source[key] === 'object') {
        if (!target[key] || typeof target[key] !== 'object') {
          target[key] = Array.isArray(source[key]) ? [] : {}
        }
        mergeDeep(target[key], source[key])
      } else {
        target[key] = source[key]
      }
    }
  }
  return target
}

/**
 * @function isReactNode ReactNodeの確認
 * @param {any} data
 */
export const isReactNode = (data) => {
  if (React.isValidElement(data)) return true
  if (data === null || data === undefined) return true
  if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') return true
  if (Array.isArray(data)) {
    return data.every((item) => isReactNode(item)) // Recursively check array elements
  }
  return false
}
